<template>
    <div class="marquee3k-container">
        <div class="marquee3k"
            :data-speed="speed"
            :data-reverse="reverse"
        >
            <p>
                <slot></slot>
                <slot></slot>
                <slot></slot>
                <slot></slot>
                <slot></slot>
                <slot></slot>
                <slot></slot>
                <slot></slot>
                <slot></slot>
                <slot></slot>
            </p>
        </div>
    </div>
</template>

<script>
    import Marquee3k from 'marquee3000'

    export default {
        props: {
            speed: {type: Number, default: () => .25},
            reverse: {type: Boolean, default: () => false}
        },
        mounted () {
            Marquee3k.init()
        }
    }
</script>